import styled from 'styled-components';
import BlueButton from 'Common/Components/BlueButton';

const Button = styled(BlueButton)`
  width: max-content;
  margin: 20px 0 17px 0;
`;
Button.displayName = 'Button';

export default Button;
